import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import { FullPageBanner } from "@/components/styles/Layout";
import UndrawBugFixing from "@/components/svg/UndrawBugFixing";
import Link from "next/link";
import React, { ErrorInfo, ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

    // // You can also log the error to an error reporting service
    // // logErrorToMyService(error, errorInfo);
    // Sentry.captureException(error);
    // await Sentry.flush();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <FullPageBanner>
          <UndrawBugFixing className="w-88" />
          <div className="mt-20 text-center font-normal">
            <h1 className="mb-8 text-gray-700">Something Went Wrong!</h1>
            <p className="mb-4 max-w-4xl text-gray-500">
              This is most likely caused by data saved in the process of
              creating a recipe.
            </p>
            <p className="mb-4 max-w-4xl text-gray-500">
              To clear this data, go to the settings (
              <Link prefetch={false} href="/settings">
                <Cog6ToothIcon className="icon-md text-gray-700" />
              </Link>
              ) page and click the orange &quot;Clear Local Data&quot; button.
            </p>
            <p className="max-w-4xl rounded bg-sky-50 p-1.5 text-sky-700 shadow">
              If this does not resolve the issue, please let us know via the
              chat widget in the bottom left corner of this page.
            </p>
          </div>
        </FullPageBanner>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
